import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/cycleCounts'
import Component from 'components/CycleCounts'

export default createListViewContainer({ actions, selectors: selectors.cycleCounts })(Component)
